import React, { ReactElement } from "react";
import styles from "./style.module.scss";
import { useTranslation } from "next-i18next";

export default function PaginationX(props: Props): ReactElement {
  const { currentPage, perPage, total } = props;
  const lastPage = Math.ceil(total / perPage);
  const LinkComponent = props.linkAs ?? "a";
  const { t } = useTranslation("questionIndexing");

  function getPageValue(page: number) {
    const urlObject = new URL(props.base, "https://dummy.link");
    if (page == 1) {
      urlObject.searchParams.delete("page");
    } else {
      urlObject.searchParams.set("page", page + "");
    }
    return urlObject.pathname + urlObject.search;
  }

  function printLeftLink() {
    if (currentPage <= 1) return null;

    return (
      <LinkComponent
        className={styles.prevNext}
        href={`${getPageValue(currentPage - 1)}`}
      >
        <span className={styles.arrowy}>{`<`}</span>{" "}
        {t("search_result_pagination_previous_button_label")}
      </LinkComponent>
    );
  }

  function printFirstPage() {
    if (currentPage <= 3) return null;
    return (
      <LinkComponent href={`${getPageValue(1)}`} className={styles.numbery}>
        1
      </LinkComponent>
    );
  }

  function printLeftSideDots() {
    if (currentPage <= 4) return null;
    return <span className={styles.spany}>...</span>;
  }

  function printPages() {
    const pagesToPrint: number[] = [];

    for (let i = currentPage - 2; i <= currentPage + 2; i++) {
      if (i >= 1 && i <= lastPage) {
        pagesToPrint.push(i);
      }
    }

    return pagesToPrint.map((p, i) => {
      if (p == currentPage) {
        return (
          <span key={i} className={styles.selectedSpany}>
            {p}
          </span>
        );
      } else {
        return (
          <LinkComponent
            href={`${getPageValue(p)}`}
            key={i}
            className={styles.numbery}
          >
            {p}
          </LinkComponent>
        );
      }
    });
  }

  function printRightSideDots() {
    if (currentPage >= lastPage - 3) return null;
    return <span className={styles.spany}>...</span>;
  }

  function printLastPage() {
    if (currentPage > lastPage - 3) return null;
    return (
      <LinkComponent
        className={styles.numbery}
        href={`${getPageValue(lastPage)}`}
      >
        {lastPage}
      </LinkComponent>
    );
  }

  function printRightLink() {
    if (currentPage >= lastPage) return null;
    return (
      <LinkComponent
        className={styles.prevNext}
        href={`${getPageValue(currentPage + 1)}`}
      >
        {t("search_result_pagination_next_button_label")}{" "}
        <span className={styles.arrowy}>{`>`}</span>
      </LinkComponent>
    );
  }

  if (total === 0) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {printLeftLink()}
      {printFirstPage()}
      {printLeftSideDots()}
      {printPages()}
      {printRightSideDots()}
      {printLastPage()}
      {printRightLink()}
    </div>
  );
}

interface Props {
  base: string;
  currentPage: number;
  perPage: number;
  total: number;
  linkAs?: React.ElementType;
}
